/* eslint-disable jira/filename-case */
import { unreportedStatsigInitialisationErrorState } from './unreportedStatsigInitialisationErrorState.tsx';

// oxlint-disable-next-line import/no-mutable-exports
export let unreportedStatsigInitialisationError: Error | undefined;

unreportedStatsigInitialisationErrorState.set = (error: Error): void => {
	unreportedStatsigInitialisationError = error;
};
